import {MY_STUFF_HASHES} from '@Libraries/my-stuff/my-stuff-library';
import {CONTENT_PLANNER_POST_COOKIE} from '@Components/content-planner/components/add-post-menu-items';
import {goBackToEvent, isEventsSocialPostingFlow} from '@Libraries/social-media-event-promotion.library';
import {deleteCookie, readCookie} from '@Utils/cookie.util';
import {openAuthenticateModal} from '@Modals/authenticate-modal/authenticate-modal-library';
import {AuthContext} from '@Libraries/login-signup-library';

export const MAX_ACCOUNT_BUTTONS_TO_SHOW = 5;
export const WIZARD_HEADER_CLASS = 'js-social-media-wizard-header js-designs-content-header';

export const WIZARD_HEADER_SELECTOR = `.${WIZARD_HEADER_CLASS.trim().split(/\s+/).join('.')}`;

// The hand-off cookie is consumed on first read, so the origin is remembered for the page's life.
let hasWizardStartedFromContentPlanner = false;

/** Gives the in-flight draft save time to reach the server before the page navigates away. */
export const redirectToMyStuffAfterDelay = (delayMs: number): void => {
  setTimeout((): void => {
    window.location.href = window.PMW.util.site_url('');
  }, delayMs);
};

const redirectToMyPosts = (): void => {
  window.location.href = window.PMW.util.site_url(`posters/mine${MY_STUFF_HASHES.socialPosts}`);
};

const redirectToContentPlanner = (): void => {
  window.location.href = window.PMW.util.site_url(`posters/mine${MY_STUFF_HASHES.contentPlanner}`);
};

/** Consumes the content-planner hand-off cookie. Call once on wizard mount, never during render. */
export const consumeWizardOriginCookie = (): void => {
  if (readCookie(CONTENT_PLANNER_POST_COOKIE)) {
    deleteCookie(CONTENT_PLANNER_POST_COOKIE);
    hasWizardStartedFromContentPlanner = true;
  }
};

const didWizardStartFromContentPlanner = (): boolean => {
  return hasWizardStartedFromContentPlanner;
};

export const getWizardExitLabel = (): string => {
  if (isEventsSocialPostingFlow()) {
    return window.i18next.t('pmwjs_my_event');
  }

  if (didWizardStartFromContentPlanner()) {
    return window.i18next.t('pmwjs_back_content_planner');
  }

  return window.i18next.t('pmwjs_back_to_my_posts');
};

export const openSocialMediaWizardAuthenticateModal = (onLoginSuccess: () => void): void => {
  openAuthenticateModal({
    fbPermissions: '',
    signupSource: 'social-media-wizard',
    authContext: AuthContext.SOCIAL_PUBLISHING,
    onLoginSuccess: (): Promise<void> => {
      onLoginSuccess();
      return Promise.resolve();
    },
  });
};

/** Leaves the settled wizard for the surface it was opened from, falling back to My Posts. */
export const exitWizardToOriginSurface = (): void => {
  if (isEventsSocialPostingFlow()) {
    goBackToEvent();
    return;
  }

  if (didWizardStartFromContentPlanner()) {
    redirectToContentPlanner();
    return;
  }

  redirectToMyPosts();
};
